/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const privacyAPI = {
  esportaDati: async () => { const { data } = await apiClient.get('/privacy/export'); return data; },
  miaRichiestaCancellazione: async () => { const { data } = await apiClient.get('/privacy/mia-richiesta-cancellazione'); return data; },
  richiediCancellazione: async () => { const { data } = await apiClient.post('/privacy/richiesta-cancellazione'); return data; },
};
